import { Component, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { CustomTooltipComponent } from '../core/custom-tooltip/custom-tooltip.component';
import { GriddataService } from '../services/griddata.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ExcelService } from '../services/excel.service';
import { OSPStateService } from '../services/osp-state.service';
import { forkJoin, Subscription } from 'rxjs';
import { LookupService } from '../services/lookup/lookup.service';
import {

  resetSortingAndFilters, validateVanningDates, warningMessage,checkInvAccess,
  getTimezone

} from '../constants';
import { logData, logErrors } from '../shared/logger';
import * as mm from 'moment-timezone';
import { ModuleType2ActionsComponent } from './module-type2-actions/module-type2-actions.component';
import { ModuleType2EditDialogComponent } from './module-type2-edit-dialog/module-type2-edit-dialog.component';
import { MatDialogConfig } from '@angular/material/dialog';
import { ModuleType2DeleteDialogComponent } from './module-type2-delete-dialog/module-type2-delete-dialog.component';
import { ColDef } from 'ag-grid-community';
import { OrderforecastService } from '../services/orderforecast/orderforecast.service';
import { ModuleStockingService } from '../services/module-stocking/module-stocking.service';
import { ModuleType2RowCheckboxComponent } from './module-type2-actions/module-type2-checkbox.componet';
import { DefaultService } from '../services/default.service';
import { ModuleTypeEditDialogComponent } from '../module-type/module-type-edit-dialog/module-type-edit-dialog.component';

@Component({
  selector: 'app-module-type2',
  templateUrl: './module-type2.component.html',
  styleUrls: ['./module-type2.component.scss']
})
export class ModuleType2Component {
  namcValue = localStorage.getItem('namcvalue');
  userName = localStorage.getItem('UserName');
  count = 0;
  rowData = [];
  @ViewChild('osPartsGrid') osPartsGrid;
  columnDefsMaster;
  // columnDefs;
  // columnDefsTemp;
  // public defaultColDef;
  rowSelection;
  user: string;
  userRole: any;
  warningMessage = '';
  offset: number = 0;
  dataCount: number = 0;
  modalComponent = 'modal-component';
  gridOptions;
  paginationPageSize;
  paginationNumberFormatter;
  pagination = 'true';
  context: any;
  editType;
  suppressClickEdit = true;
  tooltipShowDelay = 0;
  frameworkComponents = { customTooltip: CustomTooltipComponent };
  headerCheckboxChecked: boolean = false;
  partDesc = 'Part Description';
  editEnabled = false;
  freezeStatus = false;
  filter = false;
  showToggleAll = false;
  showClear = true;
  disablePartNumber: boolean;
  disableKanban: boolean;
  // Dropdowns
  selectedKanban: any = [];
  selectedPartNo: any = [];
  // selectedDestCode: any = [];
  // selectedContainer: any = [];
  // selectedSupplier: any = [];
  selectedUnloadarea: any = [];
  selectedSpecialist: any = [];
  selectedpolicyName: any = [];
  // selectedLifecycle: any = [];
  // adjList: any = [];
  selectedModuleType: any = [];
  selectedLine: any = [];
  effectiveFrom: any;
  effectiveTo: any;
  adjustSubscription$: Subscription;
  // Dropdown Options
  kanbanList: any = [];
  partNoList: any = [];
  partNoListAdd: any = [];
  // destCodeList: any = [];
  containerList: any = [];
  // supplierList: any = [];
  dockList: any = [];
  uAListForpopup: any = [];
  moduleTypeList: any = [];
  moduleTypeListForpopup: any = [];
  moduleTypeToDockForpopup: any = [];
  linePathListForpopup: any = [];
  specialistList: any = [];
  policyNameList: any = [];
  // lifecycleList: any = [];
  rowCount = 0;
  count1 = 0;
  isEditMode = false;
  successMessage = '';
  kanbanSelected = 1;
  easternDate: any;
  defaultPageSize: any = 100000;
  itContact: any;
  linePathList: any = [];
  selectedLinePath: any = [];
  lineList: any[];
  lineListForpopup: any[];
  trackingPointList: any[];
  trackingPointListForpopup: any[];
  validationMessage = '';
  access;
  accessEdit = false;
  mtDDLList : any[] = [];
  idLineDDLList: any[] = [];
  modelNameList: any[] = [];

    allMtRows: any[] = [];
  constructor(
    private readonly spinner: NgxSpinnerService,
    private readonly excelService: ExcelService,
    private readonly gridDataService: GriddataService,
    public dialog: MatDialog,
    private readonly stateService: OSPStateService,
    private readonly lookupService: LookupService,
    private readonly service: OrderforecastService,
    private readonly moduleStockingService: ModuleStockingService,
    public readonly defaultService : DefaultService
  ) {
    this.context = {
      componentParent: this,
    };
  }
  numberComparator(number1, number2) {
    return number1 - number2;
  }

  dateComparator(date1, date2) {
    function monthToNum(date) {
      if (date === undefined || date === null) {
        return null;
      }
      const newDate: Date = new Date(date);
      const yearNumber = newDate.getFullYear();
      const monthNumber = newDate.getMonth();
      const dayNumber = newDate.getDate();
      const hoursNumber = newDate.getHours();
      const minutesNumber = newDate.getMinutes();
      const result =
        yearNumber * 10000 +
        monthNumber * 100 +
        dayNumber +
        hoursNumber * 60 +
        minutesNumber * 10;
      // 29/08/2004 => 20040829
      return result;
    }

    // To be used inside filter params when using date filter

    const date1Number = monthToNum(date1);
    const date2Number = monthToNum(date2);

    if (date1Number === null && date2Number === null) {
      return 0;
    }
    if (date1Number === null) {
      return -1;
    }
    if (date2Number === null) {
      return 1;
    }

    return date1Number - date2Number;
  }

  onPageSizeChanged() {
    if (this.gridOptions?.api) {
      this.gridOptions.api.paginationSetPageSize(
        Number(this.paginationPageSize)
      );
    }
  }

  setPageSizeToAll(pageSize?) {
    this.paginationPageSize = this.rowData.length;

    if (pageSize) {
      this.paginationPageSize = 0;
      this.rowData.length = 0;
    }

    this.onPageSizeChanged();
  }

  ngOnDestroy(): void {
    this.adjustSubscription$.unsubscribe();
  }


  public columnDefs: ColDef[]

  public defaultColDef;


  ngOnInit(): void {
    this.access = checkInvAccess();
    this.accessEdit = this.access?.functionalityAccess?.edit || false;


    this.columnDefsMaster = [      
      {
        headerName: 'Unload Area',
        field: 'unload_area',
        sortable: true,
        width: 120,
        floatingFilter: true,
        tooltipField: 'unload_area',
        headerTooltip: 'Unload Area'
      },
      {
        headerName: 'Dock',
        field: 'docks',
        sortable: true,
        width: 80,
        floatingFilter: true,
        tooltipField: 'docks',
        headerTooltip: 'Dock'
      },

      {
        headerName: 'Module Description',
        field: 'module_desc',
        sortable: true,
        width: 120,
        floatingFilter: true,
        tooltipField: 'module_desc',
        headerTooltip: 'Module Description',
        // cellRenderer: "agGroupCellRenderer"
      },
        {
        headerName: 'Module Type',
        field: 'module_type',
        sortable: true,
        width: 120,
        floatingFilter: true,
        tooltipField: 'module_type',
        headerTooltip: 'Module Type',
        // cellRenderer: "agGroupCellRenderer"
      },
      {
        headerName: ' ID Line',
        field: 'galc_id_line',
        sortable: true,
        width: 80,
        floatingFilter: true,
        tooltipField: 'galc_id_line',
        headerTooltip: ' ID Line'
      },

      {
        headerName: 'Line',
        field: 'galc_line',
        sortable: true,
        width: 80,
        floatingFilter: true,
        tooltipField: 'galc_line',
        headerTooltip: 'GALC  Line'
      },
        {
        headerName: 'OSP LP',
        field: 'osp_line_paths',
        sortable: true,
        width: 120,
        floatingFilter: true,
        tooltipField: 'osp_line_path',
        headerTooltip: 'OSP Line Path'

      },
            {
        headerName: 'Model Name',
        field: 'models',
        sortable: true,
        comparator: (valueA, valueB) => {
          return valueA.localeCompare(valueB, undefined, { sensitivity: 'base' });
        },
        width: 150,
        floatingFilter: true,
        tooltipField: 'models',
        headerTooltip:'Model Name'

      },
      {
        headerName: 'Tracking Point',
        field: 'tracking_point',
        sortable: true,
        width: 140,
        floatingFilter: true,
        tooltipField: 'tracking_point',
        headerTooltip: 'Tracking Point'
      },


      {
        headerName: 'Controlling',
        field: 'is_controlling_mod',
        sortable: true,
        width: 110,
        floatingFilter: false,
        // tooltipField: 'controlling_module',
        headerTooltip: 'Controlling Module',
        floatingFilterComponentParams: { suppressFilterButton: true },
        cellRendererFramework: ModuleType2RowCheckboxComponent,
        cellRendererParams: { column: 'conModule' },
        cellClass: 'no-border',
         hide: !this.accessEdit
      },
      {
        headerName: 'Independent',
        field: 'is_independent_mod',
        sortable: true,
        width: 160,
        floatingFilter: false,
        // tooltipField: 'is_module_to_dock',
        headerTooltip: 'Indepent',
        cellRendererFramework: ModuleType2RowCheckboxComponent,
        cellRendererParams: { column: 'moduleToDock' },
        cellClass: 'no-border',
        hide: !this.accessEdit


      },
      {
        headerName: 'User',
        field: 'updated_userid',
        sortable: true,
        comparator: (valueA, valueB) => {
          return valueA.localeCompare(valueB, undefined, { sensitivity: 'base' });
        },
        width: 150,
        floatingFilter: true,
        tooltipField: 'updated_userid',
        headerTooltip: 'User'
      },
      {
        headerName: 'Updated DT',
        field: 'updated_datetime',
        sortable: true,
        comparator: (valueA, valueB) => {
          return valueA.localeCompare(valueB, undefined, { sensitivity: 'base' });
        },
        width: 160,
        floatingFilter: true,
        tooltipField: 'updated_date',
        headerTooltip: 'Updated Date(mm/dd/yyyy hh:mm:ss (Eastern))'
      },
      {
        headerName: 'Action',
        cellRendererFramework: ModuleType2ActionsComponent,
        field: 'actions',
        width: 80,
        sortable: false,
        floatingFilter: false,
        hide: !this.accessEdit

        // pinned: 'right',
      },
    ],


      this.columnDefs = [...this.columnDefsMaster];

    this.setPageSizeToAll(this.defaultPageSize);
    // this.rowData = [
    //   {updated_date : '12/16/2024'}
    // ];

    this.rowSelection = 'multiple';
    this.editType = 'fullRow';
    this.gridOptions = this.gridDataService.getGridOptions();
    this.gridOptions.onGridReady = function (params) {
      this.gridApi = params.api;
    };
    this.adjustSubscription$ = this.stateService
      .getNamc()
      .subscribe((observable) => {
        this.initializeData();
      });


  }



  initializeData() {
    this.spinner.show();
    this.spinner.show();

    this.namcValue = localStorage.getItem('namcvalue');

    if (localStorage.getItem('workdayId')) {
      this.user = localStorage.getItem('workdayId');
    }
    if (localStorage.getItem('UserRoles')) {
      this.userRole = localStorage.getItem('UserRoles');
    }



    this.loadDrop();
    this.onResetDropDown();
    // this.rowData = [
    //   {
    //     module_type : 'AF4',
    //     line : '2',
    //     unload_area : 'S1',
    //     controlling_module : '',
    //     is_module_to_dock : '',
    //     osp_line_path : '11',
    //     description : 'Camry/ Avalon Hy',
    //     tracking_point : 'A',
    //     user : 'John Doe',
    //     updated_date : '10/01/2024 21:20'
    //   }
    // ];

    // this.lookupService.getEasternDate().subscribe({
    //   error: (error) => this.errorCallback(error,'getEasternDate'),
    //   next: (res) => {
    //     this.easternDate = res.body.data;
    //   },
    // });
    this.easternDate = String(mm().tz(getTimezone(this.namcValue)).format()).substring(0,10);
  }
  

  checkIfAnySelected() {
    this.validationMessage = '';
    const msgPrefix = 'Please select '
    let msgArr = [];

    if (this.selectedUnloadarea.length === 0){
      msgArr.push('Unload Area');
    }
    if (this.selectedModuleType.length === 0){
      msgArr.push('Module Type');
    }
    if (this.selectedLine.length === 0){
      msgArr.push('Line');
    }
    
    if (msgArr.length > 0){
      this.validationMessage = `${msgPrefix}${msgArr.join(', ')}.`;
      return false;
    }
     
    return true;
  }

  resetGrid() {
    if (this.osPartsGrid) {
      resetSortingAndFilters(this.osPartsGrid);
      return;
    }
  }

  onSearch(offset) {
    //this.refreshView()
    if (this.osPartsGrid) {
      this.headerCheckboxChecked = false;
      this.osPartsGrid.gridOptions.api.refreshHeader();

      this.resetGrid();
    }

    this.removeMessage();

    if (offset === 0) {
      this.setPageSizeToAll(this.defaultPageSize);
      this.rowData = [];
      this.osPartsGrid.gridOptions.api.setRowData(this.rowData);

      const { valid, error } = validateVanningDates({
        vanningFrom: this.effectiveFrom,
        vanningTo: this.effectiveTo,
      });

      if (!valid) {
        this.warningMessage = error;
        window.scroll(0, 0);

        this.spinner.hide();

        return;
      }

      this.offset = 0;
      this.spinner.show();
    }

    if (!this.checkIfAnySelected()) {
      this.rowData = [];
      this.warningMessage = this.validationMessage;

      window.scroll(0, 0);
      this.spinner.hide();
      return false;
    }

    let kanban;
    let selectedPartNo;
    // let selectedDestCode;
    // let selectedContainer;
    // let selectedSupplier;
    let selectedUnloadarea;
    let selectedModuleType;
    let selectedLine;


    if (this.selectedModuleType.length > 0) {
      if (!this.selectedModuleType.some((a) => a.module_type === 'ALL')) {
        selectedModuleType = [];
        this.selectedModuleType.forEach((element) => {
          selectedModuleType.push(element.module_type);
        });
      }
    }

    if (this.selectedLine.length > 0) {
      if (!this.selectedLine.some((a) => a.line === 'ALL')) {
        selectedLine = [];
        this.selectedLine.forEach((element) => {
          selectedLine.push(element.line);
        });
      }
    }

    if (this.selectedUnloadarea.length > 0) {
      if (!this.selectedUnloadarea.some((a) => a.unload_area === 'ALL')) {
        selectedUnloadarea = [];
        this.selectedUnloadarea.forEach((element) => {
          selectedUnloadarea.push(element.unload_area);
        });
      }
    }

    const data = {
      offset: offset,
      limit: 12000,
      business_entity: this.namcValue,
      workid: this.user,
      user_role: this.userRole,
      module_type: selectedModuleType,
      line: selectedLine,
      unload_area: selectedUnloadarea,
      currenteasternDate: this.easternDate,
    };

    this.moduleStockingService.getmoduleType2Grid(data).subscribe({
      error: (error) => this.errorCallback(error,'getmoduleTypeGrid'),
      next: (res) => {
        if (res.body && res.body.data) {
          this.rowData.push(...res.body.data);
          this.osPartsGrid.gridOptions.api.setRowData(this.rowData);
          this.dataCount = parseInt(res.body.rowCount);
          const records = this.dataCount - (this.offset + 1) * 12000;
          if (records >= 1) {
            this.offset++;
            this.onSearch(this.offset * 12000);
          } else {
            this.spinner.hide();
          }
        } else {
          this.rowData = [];
          this.spinner.hide();
        }

        this.setPageSizeToAll();
      },
    });
    return true;
  }

//   loadDrop() {
//     this.spinner.show();

//     const data = {
//       business_entity: this.namcValue,
//       workid: this.user,
//       user_role: this.userRole,
//     };

//     const lookupSubscriptions = [
//       this.moduleStockingService.getModuleTypeDropdown(),
//       this.moduleStockingService.getIdLineDropdown(),
//       this.moduleStockingService.getModelName()
//       // this.service.getLinePath(this.namcValue, this.userRole, this.user),
//       // this.moduleStockingService.getModuleType(),
//       // this.moduleStockingService.getLine(),
//       // this.moduleStockingService.getTrackingPoint(),
//     ];
//     forkJoin(lookupSubscriptions).subscribe({
//       next: (res) => {

        
        
//         this.mtDDLList = res[0].body;
//         this.idLineDDLList = res[1].body.data;
//         this.modelNameList = res[2].body.data;

//         logData(`mtDDLList response: ${JSON.stringify(this.mtDDLList)}`);
//         logData(`idLineDDLList response: ${JSON.stringify(this.idLineDDLList)}`);
//         logData(`modelNameList response: ${JSON.stringify(this.modelNameList)}`);
// /*
//         const distinctUA = [
//           ...new Set(mtDDLRes.map((item: any) => item.unload_area))
//         ].map(unload_area => ({ unload_area }));

//         const distinctModuleType = Array.from(
//           new Map(
//             mtDDLRes.map((item: any) => [
//               `${item.module_type}${item.module_desc}`,
//               {
//                 module_type: item.module_type,
//                 module_desc: item.module_desc
//               }
//             ])
//           ).values()
//         );


//         logData(`distinctUA: ${JSON.stringify(distinctUA)}`);
//         logData(`distinctModuleType: ${JSON.stringify(distinctModuleType)}`);
//         this.uAListForpopup.push(distinctUA);
//         this.moduleTypeListForpopup.push(distinctModuleType);

//         */

//         /*
//         // get unload_area list
//         this.dockList = [];
//         this.uAListForpopup = [];
//         if (res[0].body.data) {
//           this.dockList.push({ unload_area: 'ALL' });
//         }
//         this.dockList.push(...res[0].body.data);
//         this.uAListForpopup.push(...res[0].body.data);

//         // get linepath list
//         this.linePathList = [];
//         this.linePathListForpopup = [];
//         this.linePathList = res[1].body.data;
//         if (this.linePathList.length === 1) {
//           this.selectedLinePath = this.linePathList;
//         } else {
//           this.selectedLinePath = [];
//         }
//         // this.linePathList = [];
//         // this.linePathListForpopup = [];
//         // if (res[1].body.data) {
//         //   this.linePathList.push({ line_path: 'Select' });
//         // }
//         // this.linePathList.push(...res[1].body.data);
//         // this.linePathListForpopup.push(...res[1].body.data);


//         this.moduleTypeToDockForpopup = [{ value: 'Yes' }, { value: 'No' }];

//         // get module type list
//         this.moduleTypeList = [];
//         this.moduleTypeListForpopup = [];
//         console.log(res);

//         if (res[2].body.data) {
//           this.moduleTypeList.push({ module_type: 'ALL' });
//         }
//         this.moduleTypeList.push(...res[2].body.data);
//         this.moduleTypeListForpopup.push(...res[2].body.data);

//         // get line list
//         this.lineList = [];
//         this.lineListForpopup = [];
//         console.log(res);

//         if (res[3].body.data) {
//           this.lineList.push({ line: 'ALL' });
//         }
//         this.lineList.push(...res[3].body.data);
//         this.lineListForpopup.push(...res[3].body.data);


//         // get tracking_point list
//         this.trackingPointList = [];
//         this.trackingPointListForpopup = [];
//         console.log(res);

//         if (res[4].body.data) {
//           this.trackingPointList.push({ tracking_point: 'ALL' });
//         }
//         this.trackingPointList.push(...res[4].body.data);
//         this.trackingPointListForpopup.push(...res[4].body.data);
//         if (this.assignDefaultDock()){
//           this.dockChange();
//         }
//         */
//         this.spinner.hide();
//       },
//       error: (error) => this.errorCallback(error),
//     });
//   }

loadDrop() {
  this.spinner.show();

  const lookupSubscriptions = [
    this.moduleStockingService.getModuleTypeDropdown(),
    this.moduleStockingService.getIdLineDropdown(),
    this.moduleStockingService.getModelName()
  ];

  forkJoin(lookupSubscriptions).subscribe({
    next: (res) => {
      const moduleTypeRows = Array.isArray(res[0]?.body) ? res[0].body : [];
      const idLineRows = Array.isArray(res[1]?.body?.data) ? res[1].body.data : [];
      const modelNameRows = Array.isArray(res[2]?.body?.data) ? res[2].body.data : [];

      this.mtDDLList = moduleTypeRows;
      this.allMtRows = moduleTypeRows;

      this.idLineDDLList = idLineRows;
      this.modelNameList = modelNameRows;

      this.refreshDropdowns();

      this.spinner.hide();
    },
    error: (error) => this.errorCallback(error),
  });
}

  onKeyPress(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];
    const isNumber = /^[0-9]$/.test(event.key);

    // Allow number keys, allowed keys, and prevent default for others
    if (!isNumber && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  errorCallback = (error,apiName = '') => {
    logErrors(error);
    this.spinner.hide();

    let detailedMessage = 'Something went wrong! Please contact support team.';
    let backendMessage = '';
    if(error?.error?.message){
      backendMessage = error.error.message;
    } else if(error?.message){
      backendMessage = error.message;
    }
    if(backendMessage){
      detailedMessage += `| ${backendMessage}`;
    } else if(apiName){
      detailedMessage += `| Try after some time! Error in ${apiName}`;
    }
    this.warningMessage = detailedMessage;
    this.rowData = [];
    this.osPartsGrid.gridOptions.api.setRowData(this.rowData);
  };

onResetDropDown() {
  this.removeMessage();

  this.selectedUnloadarea = [{ unload_area: 'ALL' }];
  this.selectedModuleType = [{ module_type: 'ALL' }];
  this.selectedLine = [{ line: 'ALL' }];

  this.refreshDropdowns();

  this.effectiveFrom = '';
  this.effectiveTo = '';

  if (this.osPartsGrid) {
    this.headerCheckboxChecked = false;
    this.osPartsGrid.gridOptions.api.refreshHeader();
    this.resetGrid();
  }

  this.setPageSizeToAll(this.defaultPageSize);
  this.rowData = [];
  this.offset = 0;
}
  // toogleHeaderCheckBox(checked) {
  //   if (checked) {
  //     const rowCount = this.osPartsGrid.gridOptions.rowData.length;
  //     const selectedRowCount = this.osPartsGrid.gridOptions.rowData.filter(
  //       (x) => x.rowCheckBox === true
  //     ).length;
  //     if (rowCount === selectedRowCount) {
  //       this.osPartsGrid.gridOptions.columnDefs[0].headerComponentFramework.checked =
  //         checked;
  //       this.osPartsGrid.gridOptions.api.refreshHeader();
  //     }
  //   } else {
  //     this.osPartsGrid.gridOptions.columnDefs[0].headerComponentFramework.checked =
  //       checked;
  //     this.osPartsGrid.gridOptions.api.refreshHeader();
  //   }
  // }

  toggleHeaderCheckbox(checked) {
    if (!checked) {
      this.headerCheckboxChecked = false;

      this.osPartsGrid.gridOptions.api.refreshHeader();

      return;
    }

    const rowCount = this.osPartsGrid.gridOptions.rowData.length;
    const selectedRowCount = this.osPartsGrid.gridOptions.rowData.filter(
      (x) => x.rowCheckBox === true
    ).length;

    if (rowCount === selectedRowCount) {
      this.headerCheckboxChecked = true;

      this.osPartsGrid.gridOptions.api.refreshHeader();
    }
  }
  userCheckChanged(checked, rowIndex) {
    this.spinner.show();
    const rowNode =
      this.osPartsGrid?.gridOptions?.api?.getDisplayedRowAtIndex(rowIndex);
    if (checked === true) {
      rowNode.setSelected(true);
      if (this.isEditMode) {
        rowNode.data.checkedEditMode = true;
      }
      rowNode.data.rowCheckBox = true;
    } else {
      rowNode.setSelected(false);
      rowNode.data.checkedEditMode = false;
      rowNode.data.rowCheckBox = false;
    }

    this.gridOptions.getRowStyle = function (params) {
      if (params.node.rowIndex === rowIndex) {
        const color = checked ? '#E4ECF0' : 'white';
        return { background: color };
      }
      return { background: 'white' };
    };

    rowNode.setData(rowNode.data);
    this.toggleHeaderCheckbox(checked);
    this.spinner.hide();
  }
  userCheckChanged2(checked, rowIndex) {
    this.spinner.show();
    const rowNode =
      this.osPartsGrid?.gridOptions?.api?.getDisplayedRowAtIndex(rowIndex);
    if (checked === true) {
      rowNode.setSelected(true);
      if (this.isEditMode) {
        rowNode.data.checkedEditMode = true;
      }
      rowNode.data.rowCheckBox = true;
    } else {
      rowNode.setSelected(false);
      rowNode.data.checkedEditMode = false;
      rowNode.data.rowCheckBox = false;
    }

    this.gridOptions.getRowStyle = function (params) {
      if (params.node.rowIndex === rowIndex) {
        const color = checked ? '#E4ECF0' : 'white';
        return { background: color };
      }
      return { background: 'white' };
    };

    rowNode.setData(rowNode.data);
    this.toggleHeaderCheckbox(checked);
    this.spinner.hide();
  }
  headerCheckChanged(event) {
    this.headerCheckboxChecked = event.checked;
    const headerChecked = event.checked;
    const isEditable = this.isEditMode;
    this.osPartsGrid.gridOptions.api.forEachNode(function (rowNode, index) {
      if (headerChecked) {
        if (isEditable) {
          rowNode.data.checkedEditMode = true;
        }
        rowNode.data.rowCheckBox = true;
      } else {
        rowNode.data.rowCheckBox = false;
        rowNode.data.checkedEditMode = false;
      }
      rowNode.setData(rowNode.data);
    });
  }



  assignDefaultDock(){
    try {
      if (this.dockList?.length > 0){
        const defaultdockArray : any[] = JSON.parse(this.defaultService.getCurrentDockCode());
        if (Array.isArray(defaultdockArray)){
          const validDocks = new Set(defaultdockArray.map(item => item.unload_area));
          this.selectedUnloadarea = this.dockList.filter(item => validDocks.has(item.unload_area));
          if (this.selectedUnloadarea && this.selectedUnloadarea.length > 0){
            return true;
          }
        }
      }
      return false;
    } catch (error) {
      console.log('Error in assigning default unload_area',error);
      return false;
    }
  }






  getModifiedRowData(): any {
    return this.rowData.filter((row) => row.rowCheckBox);
  }
  exportAsXLSX(): void {
    this.removeMessage();

    this.spinner.show();

    // eastern time api

    const easternCurrentDate = String(
      mm().tz(getTimezone(this.namcValue)).format('YYYY-MM-DD_HH:mm:ss')
    );
    console.log(easternCurrentDate);
    let data = [];

    if (this.headerCheckboxChecked) {
      this.osPartsGrid.gridOptions.api.forEachNodeAfterFilter((node) => {
        data.push(node.data);
      });
    } else {
      data = this.getModifiedRowData();
    }

    if (data.length < 1) {
      this.spinner.hide();
      this.warningMessage = warningMessage.noRowsSelected;

      window.scroll(0, 0);
    } else {
      setTimeout(async () => {
        if (this.rowData.length > 0) {
          const exportData: any = [];

          data.forEach((e) => {
            const obj = {
              moduleType: e.module_type,
              line: e.line,
              unload_area: e.unload_area,
            };
            exportData.push(obj);
          });

          const headers = [
            'MODULE TYPE',
            'LINE',
            'DOCK',
            'CONTROLLING MODULE',
            'DOCK MODULE TYPE ACTIVE',
            'OSP LINE PATH',
            'DESCRIOTION',
            'TRACKING POINT',
            'UPDATED DT',
            'USER',
          ];

          const timestamp = easternCurrentDate

            .split('.')[0]
            .replace('T', '_')
            .split('')

            .filter((d) => d !== '-' && d !== ':')
            .join('');

          this.excelService.exportAsExcelFile(
            exportData,
            'AdjustmentInquiry_' + timestamp,

            headers
          );
        }
        this.spinner.hide();
      }, 1000);
    }
  }
  removeMessage() {
    this.warningMessage = '';
    this.successMessage = '';
  }






  userDeleteChanged(rowIndex) {
    const rowNode =
      this.osPartsGrid.gridOptions.api.getDisplayedRowAtIndex(rowIndex);

    // this.mdid = rowNode.data.master_id;
    // this.mdkey = rowNode.data.key_item.trim();
    this.opendeleteDialog(rowNode.data);
  }

  userEdit(rowIndex) {
    const rowNode =
      this.osPartsGrid.gridOptions.api.getDisplayedRowAtIndex(rowIndex);

    // this.mid = rowNode.data.master_id;
    // this.mname = rowNode.data.name;
    // this.mkey = rowNode.data.key_item.trim();
    // this.mdata = rowNode.data.data_item.trim();
    this.openeditDialog(rowNode.data);
  }

  checkBoxEdit(rowIndex) {
    const rowNode =
      this.osPartsGrid.gridOptions.api.getDisplayedRowAtIndex(rowIndex);
    this.openeditDialog(rowNode.data);
  }

  
  editModuleTypeCheck(params){

    let urlValue: any;
    if (params.column === 'conModule'){
      urlValue = "is_controlling_module";
    } else if (params.column === 'moduleToDock'){
      urlValue = "is_module_to_dock";
    } else{
      //do nothing
    }

     const data =  {
        business_entity: this.namcValue,
        workid: this.user,
        user_role: this.userRole,
        userid: this.userName,
        unload_area: params.data.unload_area,
        line : params.data.line,
        module_type : params.data.module_type,
        is_controlling_module : params.data.is_controlling_module,
        is_module_to_dock : params.data.is_module_to_dock
      }
      this.spinner.show();
      this.moduleStockingService.editModuleTypeCheck(data, urlValue).subscribe({
        error: (error) => this.errorCallback(error,'editModuleTypeCheck'),
        next: (data) => {
          this.onSearch(0);
        },
      });

  }

  
  //delete dialog popup
  opendeleteDialog(dataTODelete) {
    console.log("dataTODelete", dataTODelete);
    var data = {
      business_entity: this.namcValue,
      workid: this.user,
      user_role: this.userRole,
      userid: this.userName,
      unload_area: dataTODelete?.unload_area,
      module_type: dataTODelete?.module_type
    }
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = this.modalComponent;

    dialogConfig.width = '390px';
    const dialogRef = this.dialog.open(ModuleType2DeleteDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((res) => {
      this.removeMessage();
      if (res === 'cancel') {
        return;
      }
      if (res === 'save') {
        console.log("inside save")
        const delMessage = `Module Type "${data.module_type}" associated with Dock "${data.unload_area}" has been deleted.`;
        this.spinner.show();
        this.moduleStockingService.deleteModuleType(data).subscribe({
          error: (error) => this.errorCallback(error,'deleteModuleType'),
          next: (data) => {
            console.log(data)
            if (data.body.DeletedCount >= 1) {
              this.onSearch(0);              
              this.successMessage = delMessage;
              this.spinner.hide();
              window.scroll(0, 0);
            } else {
              this.warningMessage = `${warningMessage.apiLogicFail}  ${this.itContact}.`;
              this.rowData = [];
              this.osPartsGrid.gridOptions.api.setRowData(this.rowData);
              this.spinner.hide();
            }
          },
        });

        // return;
      }

      // this.OspService.deleteMasterDetails(
      //   res.business_entity,
      //   this.userRole,
      //   this.user,
      //   this.mdid,
      //   this.mdkey
      // ).subscribe({
      //   error: this.errorCallback,
      //   next: (data) => {
      //     if (data.body.masterdeleteResponse === 1) {
      //       this.successMessage = successMessage.deleteRecord;
      //       this.spinner.hide();
      //       window.scroll(0, 0);
      //       this.loadMasterDetails();
      //     } else {
      //       this.warningMessage = `${warningMessage.apiLogicFail}  ${this.itContact}.`;
      //       this.rowData = [];
      //       this.osPartsGrid.gridOptions.api.setRowData(this.rowData);
      //       this.master_id = '';
      //       this.m_name = '';
      //       this.spinner.hide();
      //     }
      //   },
      // });
    });
  }
  //edit dialog popup
  updatedRows = [];  

  openeditDialog(data) {
    console.log("edit clicked");
    console.log("data", data)
    const isControllingModule = data.is_controlling_module;
    // this.successMessage = successMessage.moduleTypeUpdated;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = this.modalComponent;
    dialogConfig.width = '650px';
    dialogConfig.data = {
      partNoList: this.partNoListAdd,
      dockList: this.uAListForpopup,
      linePathList: this.linePathList,
      moduleTypeToDockList: this.moduleTypeToDockForpopup,
      moduleTypeList: this.moduleTypeListForpopup,
      lineList: this.lineListForpopup,
      trackingPointList: this.trackingPointListForpopup,
      data,
      mode: 'edit',
    };

    const dialogRef = this.dialog.open(ModuleType2EditDialogComponent, dialogConfig);
    const editGetResponse = dialogRef.componentInstance.editMasterEventEmitter.subscribe((res) => {
      console.log("Emission received:", res); // Add this to check if the event is triggered
      var data1 = {
        module_type: res.module_type,
        module_description: res.module_desc,
        line: res.line,
        unload_area: res.unload_area,
        osp_line_path: res.line_path,
        galc_tracking_point: res.tracking_point,
        is_module_to_dock: res.is_module_type_to_dock,
        is_controlling_module: isControllingModule,
        created_userid: this.user,
        userid: this.userName,
      };

      var data = {
        business_entity: this.namcValue,
        workid: this.user,
        user_role: this.userRole,
        userid: this.userName,
        unload_area:  res.unload_area,
        data: [data1]
      };

      this.spinner.show();
      const editMessage = `Module Type "${data1.module_type}" associated with Dock "${data1.unload_area}" has been updated.`;
      this.moduleStockingService.editModuleType(data).subscribe({
        error: (error) => this.errorCallback(error,'editModuleType'),
        next: (response) => {
          this.updatedRows.push(...response.body.updatedRows);
          console.log("API Response:", response);
          if (this.updatedRows.length > 0) {
            this.successMessage = editMessage;
            this.spinner.hide();
            this.rowData = this.updatedRows;
            this.updatedRows = [];
          } else {
            this.updatedRows = [];
            this.warningMessage = `${warningMessage.reportsNotUpdated}  ${this.itContact}.`;
          }
    
          this.spinner.hide();
        },
      });
    });






  }

  addedRows = [];

  openDialog() {
    this.removeMessage();


    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = this.modalComponent;
    dialogConfig.width = '650px';
    // dialogConfig.height = '500px';
    dialogConfig.data = {
      mtDDLList: this.mtDDLList,    
      idLineDDLList: this.idLineDDLList,
      modelNameList: this.modelNameList,
      mode: 'add',
    };
    const dialogRef = this.dialog.open(ModuleType2EditDialogComponent, dialogConfig);
    const addGetResponse =
      dialogRef.componentInstance.addMasterEventEmitter.subscribe((res) => {
        console.log("res---", res);
        var data = {
          business_entity: this.namcValue,
          workid: this.user,
          user_role: this.userRole,
          userid: this.userName,
          module_type: res.module_type,
          module_description: res.module_desc,
          line: res.line,
          unload_area: res.unload_area,
          osp_line_path: res.line_path,
          tracking_point: res.tracking_point,
          is_module_to_dock: res.is_module_type_to_dock,
          is_controlling_module: false,
          created_userid: this.user,
          updated_userid: this.user,
          batch_run_logid: "1"
        }
        this.spinner.show();
        const addMessage = `Module Type "${data.module_type}" associated with Dock "${data.unload_area}" has been added.`;
        this.moduleStockingService.addModuleType(
          data
        ).subscribe({
          error: (error) => this.errorCallback(error,'addModuleType'),
          next: (response) => {
          console.log("API Response:", response);
          this.addedRows.push(...response.body.updatedRows);
          if (this.addedRows.length > 0) {
            this.successMessage = addMessage;
            this.spinner.hide();
            this.rowData = this.addedRows;
            this.addedRows = [];
          } else {
            this.addedRows = [];
            this.warningMessage = `${warningMessage.reportsNotUpdated}  ${this.itContact}.`;
          }
          this.spinner.hide();
          },
        });
      });
    dialogRef.componentInstance.moduleTypeChanged.subscribe((res) => {
      console.log("Hii");
    });

    dialogRef.afterClosed().subscribe((res) => {
      addGetResponse.unsubscribe();
    });
  }


private refreshDropdowns(): void {
  const rows = [...this.allMtRows];

  const unloadSelected = (this.selectedUnloadarea || []).filter(
    (x) => x.unload_area !== 'ALL'
  );
  const moduleSelected = (this.selectedModuleType || []).filter(
    (x) => x.module_type !== 'ALL'
  );
  const lineSelected = (this.selectedLine || []).filter(
    (x) => x.line !== 'ALL'
  );

  const buildOptions = (
    field: 'unload_area' | 'module_type' | 'galc_line',
    outputKey: 'unload_area' | 'module_type' | 'line'
  ) => {
    const filteredRows = rows.filter((row: any) => {
      const matchUnload =
        unloadSelected.length === 0 ||
        unloadSelected.some((x) => x.unload_area === row.unload_area);

      const matchModule =
        moduleSelected.length === 0 ||
        moduleSelected.some((x) => x.module_type === row.module_type);

      const matchLine =
        lineSelected.length === 0 ||
        lineSelected.some((x) => String(x.line) === String(row.galc_line));

      if (field === 'unload_area') {
        return matchModule && matchLine;
      }

      if (field === 'module_type') {
        return matchUnload && matchLine;
      }

      return matchUnload && matchModule;
    });

    const map = new Map<string, any>();

    filteredRows.forEach((row: any) => {
      const value = row[field];
      if (value !== null && value !== undefined && value !== '') {
        map.set(String(value), { [outputKey]: value });
      }
    });

    return [
      { [outputKey]: 'ALL' },
      ...Array.from(map.values()),
    ];
  };

  this.dockList = buildOptions('unload_area', 'unload_area');
  this.moduleTypeList = buildOptions('module_type', 'module_type');
  this.lineList = buildOptions('galc_line', 'line');
}

lineChange(): void {
  if (this.selectedLine?.length) {
    const lastValue = this.selectedLine[this.selectedLine.length - 1];

    if (lastValue?.line === 'ALL') {
      this.selectedLine = [{ line: 'ALL' }];
    } else {
      this.selectedLine = this.selectedLine.filter(
        (item: any) => item?.line !== 'ALL'
      );
    }
  }

  this.refreshDropdowns();
}

moduleTypeChange(): void {
  if (this.selectedModuleType?.length) {
    const lastValue = this.selectedModuleType[this.selectedModuleType.length - 1];

    if (lastValue?.module_type === 'ALL') {
      this.selectedModuleType = [{ module_type: 'ALL' }];
    } else {
      this.selectedModuleType = this.selectedModuleType.filter(
        (item: any) => item?.module_type !== 'ALL'
      );
    }
  }

  this.refreshDropdowns();
}

UnloadareaChange(): void {
  if (this.selectedUnloadarea?.length) {
    const lastValue = this.selectedUnloadarea[this.selectedUnloadarea.length - 1];

    if (lastValue?.unload_area === 'ALL') {
      this.selectedUnloadarea = [{ unload_area: 'ALL' }];
    } else {
      this.selectedUnloadarea = this.selectedUnloadarea.filter(
        (item: any) => item?.unload_area !== 'ALL'
      );
    }
  }

  this.refreshDropdowns();
  this.defaultService.setDockCode(JSON.stringify(this.selectedUnloadarea || []));
}

}
